import { useState } from "react"
import Input from "./ui/Input"
import Button from "./ui/Button"
import Badge from "./ui/Badge"

export default function Footer() {
    const year = new Date().getFullYear()

    const [email, setEmail] = useState("")
    const [status, setStatus] = useState("idle")
    const [msg, setMsg] = useState("")
    const [hp, setHp] = useState("")

    async function handleSubscribe(e) {
        e.preventDefault()
        if (hp) {
            setStatus("success")
            setMsg("Thanks!")
            setEmail("")
            return
        }
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            setStatus("error")
            setMsg("Please enter a valid email address.")
            return
        }
        setStatus("loading")
        setMsg("")
        try {
            const endpoint = process.env.REACT_APP_SUBSCRIBE_ENDPOINT || "/api/subscribe"
            const res = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, source: "footer", hp }),
            })
            let data = {}
            const ct = res.headers.get("content-type") || ""
            if (ct.includes("application/json")) {
                data = await res.json().catch(() => ({}))
            }
            if (res.ok && data?.ok !== false) {
                setStatus("success")
                setMsg(data?.already ? "You're already subscribed." : "Thanks! You've been added to the list.")
                setEmail("")
            } else {
                setStatus("error")
                setMsg(data?.error || "Something went wrong. Please try again in a moment.")
            }
        } catch (err) {
            setStatus("error")
            setMsg("Something went wrong. Please try again in a moment.")
        }
    }

    return (
        <footer className="border-t-2 border-black bg-white text-zinc-700 dark:border-white dark:bg-zinc-950 dark:text-zinc-300">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-6 py-10 md:grid-cols-2">
                <div>
                    <h2 className="text-xl font-bold text-zinc-900 dark:text-zinc-100">DS Portfolio</h2>
                    <p className="mt-2 text-sm">
                        Showcasing my projects, blogs, and creative work.
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2">
                        <Badge>React</Badge>
                        <Badge>Tailwind</Badge>
                        <Badge>Sanity</Badge>
                    </div>
                </div>

                <div>
                    <h3 className="mb-3 text-lg font-semibold text-zinc-900 dark:text-zinc-100">Stay Updated</h3>
                    <form onSubmit={handleSubscribe} className="flex flex-col gap-2 sm:flex-row" noValidate>
                        <input
                            type="text"
                            name="company"
                            value={hp}
                            onChange={(e) => setHp(e.target.value)}
                            className="hidden"
                            tabIndex={-1}
                            autoComplete="off"
                        />

                        <label htmlFor="newsletter-email" className="sr-only">
                            Email
                        </label>
                        <Input
                            id="newsletter-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="flex-grow"
                            aria-invalid={status === "error"}
                            aria-describedby={status !== "idle" ? "newsletter-status" : undefined}
                            required
                        />
                        <Button type="submit" disabled={status === "loading"}>
                            {status === "loading" ? "Subscribing" : "Subscribe"}
                        </Button>
                    </form>
                    <p
                        id="newsletter-status"
                        role="status"
                        aria-live="polite"
                        className="mt-2 text-xs text-zinc-600 dark:text-zinc-400"
                    >
                        {msg}
                    </p>
                </div>
            </div>

            <div className="border-t border-zinc-200 py-4 text-center text-xs text-zinc-500 dark:border-zinc-700 dark:text-zinc-400">
                © {year} DS Portfolio. All rights reserved.
            </div>
        </footer>
    )
}